export default __webpack_public_path__ + "static/media/chat-bubble.47218162.svg";